<main>
  <app-client-info-form
    [clientProfileInfo]="clientProfileInfo"
    [isLoading]="isClientProfileInfoLoading"
    (editClick)="openEditClientInfoModal()"
  ></app-client-info-form>

  <div class="profile-section">
    <app-client-numbers-form
      [clientNumbers]="clientNumbers"
      (buyClick)="openBuyClientNumberModal()"
      (selectNumber)="changePrimaryClientNumber($event)"
    ></app-client-numbers-form>

    <app-cover-pages-list
      [coverPages]="coverPages"
      (editClick)="openEditCoverPageModal($event)"
      (addClick)="openCreateCoverPageModal()"
      (deleteClick)="openDeleteCoverPageModal($event)"
    ></app-cover-pages-list>
  </div>
</main>

<app-edit-client-info-modal
  [clientProfileInfo]="clientProfileInfo"
  (submit)="addOrUpdateClientInfo($event)"
></app-edit-client-info-modal>

<app-buy-client-number-modal
  (submit)="createAndOpenClientNumberPaymentLink($event)"
></app-buy-client-number-modal>

<app-create-cover-page-modal
  [clientNumbers]="clientNumbers"
  (submit)="createCoverPage($event)"
></app-create-cover-page-modal>

<app-edit-cover-page-modal
  [isSaving]="isCoverPageSaving"
  [coverPage]="selectedCoverPage"
  [clientNumbers]="clientNumbers"
  (submit)="updateCoverPage($event)"
></app-edit-cover-page-modal>

<app-delete-cover-page-modal
  [coverPageTitle]="selectedCoverPage?.title"
  (submit)="deleteCoverPage()"
></app-delete-cover-page-modal>

<app-success-modal
  [text]="successModalText"
  [buttonText]="successModalButtonText"
></app-success-modal>

<app-missing-subscription-error-modal
  [modalName]="MissingProfileInfo"
  title="Complete your profile"
  text="Please fill in your account information before purchasing a subscription."
  buttonText="Fill in profile"
  (chooseNumber)="openEditClientInfoModal()"
></app-missing-subscription-error-modal>

<app-error-modal></app-error-modal>
